import datos from "src/services/datos";
import { esArray } from "src/general_components/functionEsArray";

/**
 * Llama al servicio ctaCte de comprobantes y retorna el listado
 * de artículos acumulados (cantidad + importe) para el cliente
 * en el rango de fechas indicado.
 *
 * @param {object} params - { id_cuentas, fecha_desde, fecha_hasta }
 * @returns {Array} Filas listas para el DataGrid: { id, nombre, cantidad, importe }
 */
export const getResumenCuenta = async (params) => {
  const comprobantes = new datos("comprobantes");
  const response = await comprobantes.comprobantesCtaCte({
    id_cuentas: params.id_cuentas,
    fecha_desde: params.fecha_desde,
    fecha_hasta: params.fecha_hasta,
  });

  if (!response || response.status !== "true") {
    return [];
  }

  const wsResponse = response.wsResponse;

  if (!wsResponse || !wsResponse.articulos || !wsResponse.articulos.articulo) {
    return [];
  }

  const arr = esArray(wsResponse.articulos.articulo);

  return arr.map((item, idx) => ({
    id: parseInt(item.id_articulos, 10) || idx,
    nombre: item.nombre ?? "",
    cantidad: parseInt(item.cantidad, 10) || 0,
    importe: parseFloat(item.importe) || 0,
  }));
};
